import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "../../svgs/close.svg";
import styles from "./modal.module.scss";

interface ModalProps {
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  content?: React.ReactNode;
  maxWidth?: Breakpoints;
}
type Breakpoints = "xs" | "sm" | "md" | "lg" | "xl";

const CustomModal: React.FC<ModalProps> = ({
  title,
  icon,
  open,
  handleClose,
  content,
  maxWidth,
}) => {
  return (
    <Dialog className={styles.modal} open={open} onClose={handleClose} fullWidth maxWidth={maxWidth}>
      <div className={styles.dialog}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        {icon && icon}
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ width: "100%" }}>
          {content && content}
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default CustomModal;
